import { render, staticRenderFns } from "./subject-select.vue?vue&type=template&id=abbf7b4c&scoped=true&"
import script from "./subject-select.vue?vue&type=script&lang=js&"
export * from "./subject-select.vue?vue&type=script&lang=js&"
import style0 from "./subject-select.vue?vue&type=style&index=0&id=abbf7b4c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abbf7b4c",
  null
  
)

export default component.exports